import { createContext, ReactNode, useContext } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import { bznavRefundUserPhoneQuery } from '@/__generated__/bznavRefundUserPhoneQuery.graphql';
import { bznavRefundUserPhone } from '@/graphql/query/tax-refund/bznav-refund';

type PhoneNumberQueryRefType = PreloadedQuery<bznavRefundUserPhoneQuery, Record<string, unknown>>;

interface PhoneNumberContextType {
  hasBznavPhoneNumber: boolean;
  phoneNumber: string;
}

const PhoneNumberContext = createContext<PhoneNumberContextType>({} as PhoneNumberContextType);

export const usePhoneNumberInBznavUserInfo = () => useContext<PhoneNumberContextType>(PhoneNumberContext);

export const BznavPhoneNumberContextProvider = ({ children, queryRef }: { children: ReactNode; queryRef: PhoneNumberQueryRefType | null | undefined }) => {
  if (!queryRef) {
    return <></>;
  }
  return <FetchPhoneNumber queryRef={queryRef}>{children}</FetchPhoneNumber>;
};

function FetchPhoneNumber({ children, queryRef }: { children: ReactNode; queryRef: PhoneNumberQueryRefType }) {
  const result = usePreloadedQuery<bznavRefundUserPhoneQuery>(bznavRefundUserPhone, queryRef);
  return (
    <PhoneNumberContext.Provider
      value={{
        hasBznavPhoneNumber: !!result.bznavRefund.user.phone,
        phoneNumber: result.bznavRefund.user.phone || ''
      }}
    >
      {children}
    </PhoneNumberContext.Provider>
  );
}
